import React from 'react';
import company from '../data/company';
import { ArrowRight } from 'lucide-react';
import { generateGeneralWhatsAppLink } from '../data/products';
import { FACTORY_PHOTOS, FACTORY_VIDEO, PRODUCT_IMAGES } from '../data/images';

const About = () => {
  return (
    <div style={{ paddingTop: 'calc(var(--nav-height) + 0px)', paddingBottom: '100px' }}>

      {/* Full-width Hero Image Banner */}
      <section style={{ position: 'relative', width: '100%', height: 'clamp(260px, 40vw, 480px)', overflow: 'hidden', marginBottom: '0' }}>
        <img
          src={PRODUCT_IMAGES[1]}
          alt="RAYYAN DENIM About"
          fetchpriority="high"
          loading="eager"
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center center', display: 'block' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(15,23,42,0.35) 0%, rgba(15,23,42,0.7) 100%)' }} />
        <div style={{ position: 'absolute', bottom: '32px', left: '0', right: '0' }}>
          <div className="container">
            <span className="section-badge" style={{ background: 'rgba(255,255,255,0.15)', borderColor: 'rgba(255,255,255,0.4)', color: '#ffffff' }}>CORPORATE OVERVIEW</span>
            <h1 style={{ fontSize: 'clamp(32px, 5vw, 60px)', fontFamily: 'var(--font-heading)', fontWeight: 900, textTransform: 'uppercase', color: '#ffffff', marginTop: '10px' }}>
              ABOUT <span className="brand-name" style={{ color: 'var(--accent-magenta)' }}>RAYYAN DENIM</span>
            </h1>
          </div>
        </div>
      </section>

      {/* Brand Profile */}
      <section style={{ padding: '72px 0', background: '#ffffff', borderBottom: '1px solid rgba(15, 23, 42, 0.08)' }}>
        <div className="container">
          <div style={{ maxWidth: '760px', marginBottom: '40px' }}>
            <span className="section-badge">BRAND PROFILE</span>
            <h2 style={{ fontSize: '32px', fontFamily: 'var(--font-heading)', color: 'var(--text-main)', margin: '16px 0 18px', textTransform: 'uppercase', fontWeight: 900 }}>
              BOLD DENIM. <span className="gradient-text">HOMEGROWN REACH.</span>
            </h2>
            <p style={{ fontSize: '16px', color: 'var(--text-muted)', lineHeight: '1.7', margin: 0 }}>
              {company.brandProfile.overview}
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px', marginBottom: '32px' }}>
            {[
              ['Founded', company.brandProfile.founded],
              ['Founders / Leadership', company.brandProfile.leadership],
              ['Headquarters', company.brandProfile.headquarters],
              ['Presence', company.brandProfile.presence]
            ].map(([label, value]) => (
              <div key={label} style={{ padding: '22px', background: '#f8fafc', border: '1px solid rgba(15, 23, 42, 0.08)', borderTop: '3px solid var(--accent-magenta)' }}>
                <div style={{ fontSize: '11px', fontWeight: 800, color: 'var(--accent-purple)', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '8px' }}>{label}</div>
                <div style={{ fontSize: '15px', color: 'var(--text-main)', fontWeight: 700, lineHeight: 1.45 }}>{value}</div>
              </div>
            ))}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px' }}>
            <div>
              <h3 style={{ fontSize: '18px', fontFamily: 'var(--font-heading)', color: 'var(--text-main)', marginBottom: '8px', textTransform: 'uppercase' }}>Product Offerings</h3>
              <p style={{ fontSize: '14px', color: 'var(--text-muted)', lineHeight: 1.7, margin: 0 }}>{company.brandProfile.products}</p>
            </div>
            <div>
              <h3 style={{ fontSize: '18px', fontFamily: 'var(--font-heading)', color: 'var(--text-main)', marginBottom: '8px', textTransform: 'uppercase' }}>Distribution</h3>
              <p style={{ fontSize: '14px', color: 'var(--text-muted)', lineHeight: 1.7, margin: 0 }}>{company.brandProfile.distribution}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Are */}
      <section style={{ padding: '60px 0', borderTop: '1px solid rgba(15, 23, 42, 0.08)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '48px', alignItems: 'center' }}>
            <div>
              <span className="section-badge">WHO WE ARE</span>
              <h2 style={{ fontSize: '32px', fontFamily: 'var(--font-heading)', color: 'var(--text-main)', marginBottom: '20px', textTransform: 'uppercase', fontWeight: 900 }}>
                A PREMIUM DENIM COMPANY FOR GLOBAL CORPORATE MARKETS
              </h2>
              <p style={{ fontSize: '15px', color: 'var(--text-muted)', lineHeight: '1.7', marginBottom: '20px' }}>
                RAYYAN DENIM operates with a clear export objective: supplying international denim buyers, global importers, retail store chains, and apparel distributors with premium RAYYAN DENIM branded export collections.
              </p>
              <p style={{ fontSize: '15px', color: 'var(--text-muted)', lineHeight: '1.7', marginBottom: '32px' }}>
                From yarn weave inspection to washing character, we prioritize visual excellence, structural integrity, and export packaging standard compliance so our corporate partners receive stock ready for immediate commercial distribution.
              </p>
              <a href={generateGeneralWhatsAppLink("About Page Inquiry")} target="_blank" rel="noopener noreferrer" className="btn-primary">
                <span>TALK TO OUR TEAM</span>
                <ArrowRight size={18} />
              </a>
            </div>

            <div style={{ borderRadius: '16px', overflow: 'hidden', border: '1px solid var(--color-border)', boxShadow: '0 12px 32px rgba(15, 23, 42, 0.1)', position: 'relative' }}>
              <img
                src={FACTORY_PHOTOS[0]}
                alt="RAYYAN Denim Craftsmanship"
                fetchpriority="high"
                loading="eager"
                decoding="async"
                style={{ width: '100%', height: '100%', maxHeight: '480px', objectFit: 'cover', display: 'block' }}
              />
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  padding: '24px',
                  background: 'linear-gradient(to top, rgba(15, 23, 42, 0.9), transparent)',
                  color: '#ffffff'
                }}
              >
                <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: '18px' }}>
                  PRECISION IN EVERY DETAIL
                </div>
                <div style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.8)' }}>From raw cotton to finished export carton.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Factory and Collection Media */}
      <section style={{ padding: '80px 0', background: '#f8fafc', borderTop: '1px solid rgba(15, 23, 42, 0.06)', borderBottom: '1px solid rgba(15, 23, 42, 0.06)' }}>
        <div className="container">
          <div style={{ maxWidth: '720px', marginBottom: '36px' }}>
            <span className="section-badge">FACTORY & COLLECTIONS</span>
            <h2 className="section-title">
              SEE THE <span className="gradient-text">RAYYAN DENIM WORLD</span>
            </h2>
            <p className="section-subtitle" style={{ margin: 0 }}>
              Explore our uploaded factory and denim collection moments from Bhavnagar, Gujarat.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px', alignItems: 'stretch' }}>
            <div style={{ minHeight: '360px', borderRadius: '16px', overflow: 'hidden', background: '#0f172a', boxShadow: '0 12px 32px rgba(15, 23, 42, 0.12)' }}>
              <video
                src={FACTORY_VIDEO}
                poster={FACTORY_PHOTOS[0]}
                controls
                muted
                loop
                playsInline
                preload="metadata"
                aria-label="RAYYAN DENIM factory video"
                style={{ width: '100%', height: '100%', minHeight: '360px', objectFit: 'cover', display: 'block' }}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '14px' }}>
              {FACTORY_PHOTOS.slice(1).map((image, index) => (
                <img
                  key={image}
                  src={image}
                  alt={`RAYYAN DENIM factory and collection image ${index + 1}`}
                  loading="lazy"
                  style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '12px', display: 'block' }}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach (4 Pillars) */}
      <section style={{ padding: '80px 0', background: '#f8fafc', borderTop: '1px solid rgba(15, 23, 42, 0.06)', borderBottom: '1px solid rgba(15, 23, 42, 0.06)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 60px' }}>
            <span className="section-badge">METHODOLOGY</span>
            <h2 className="section-title">
              OUR <span className="gradient-text">APPROACH</span>
            </h2>
            <p style={{ color: 'var(--text-muted)', fontSize: '16px' }}>
              How we maintain excellence across production cycles and international corporate relationships.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '32px' }}>
            {company.pillars.map((pillar, idx) => (
              <div key={idx} className="glass-panel" style={{ padding: '36px 28px', borderLeft: '4px solid var(--accent-magenta)' }}>
                <h3 style={{ fontSize: '20px', fontFamily: 'var(--font-heading)', color: 'var(--text-main)', marginBottom: '8px', fontWeight: 800 }}>
                  {pillar.title}
                </h3>
                <p style={{ fontSize: '13px', fontWeight: 700, color: 'var(--accent-purple)', marginBottom: '14px' }}>
                  {pillar.subtitle}
                </p>
                <p style={{ fontSize: '14px', color: 'var(--text-muted)', lineHeight: '1.6' }}>
                  {pillar.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;
